import styled from 'styled-components';
import { spacing, colors } from 'ui/theme';

export const GreyBorderedContainer = styled.div`
  background: ${colors.grey1};
  border: ${spacing.single} solid ${colors.grey15};
  border-radius: ${spacing.quarter};
  margin: ${spacing.base} 0;
  padding: ${spacing.plusHalf};
`;
